import axios from 'axios';
import { interceptor } from './interceptors';

const baseURL = process.env.VUE_APP_WEBADAPTER_API_BASEURL;

const http = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    'X-Nsft-SCD-Version': 3,
  },
});

http.interceptors.request.use(interceptor, (error) => Promise.reject(error));

export default http;
